module.exports = __webpack_public_path__ + "static/media/email.a7b46ecb.png";